import { render } from "./VerticalTimeLineItemView.vue?vue&type=template&id=3874a9fe&scoped=true&ts=true"
import script from "./VerticalTimeLineItemView.vue?vue&type=script&lang=ts"
export * from "./VerticalTimeLineItemView.vue?vue&type=script&lang=ts"

import "./VerticalTimeLineItemView.vue?vue&type=style&index=0&id=3874a9fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3874a9fe"]])

export default __exports__